import { render, staticRenderFns } from "./Tp-check.vue?vue&type=template&id=5788dda0&scoped=true"
import script from "./Tp-check.vue?vue&type=script&lang=js"
export * from "./Tp-check.vue?vue&type=script&lang=js"
import style0 from "./Tp-check.vue?vue&type=style&index=0&id=5788dda0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5788dda0",
  null
  
)

export default component.exports